import React, { useRef, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux';

import './style.scss';
export default function CampaignViewDesign({ htmlData, abTestHtmlData }) {
  const {
    currentABTestCampaign
  } = useSelector((state) => state.campaignSetter);
  const iFrameRef = useRef(null);

  const htmlInIframe = (htmlData) => {
    if (!iFrameRef.current)
      return
    try{
      var doc = iFrameRef.current.contentWindow.document;
    doc.open();
    doc.write(htmlData);
    doc.close();
    }catch(e){console.log(e)}
  }

  useEffect(() => {
    if (currentABTestCampaign === 'A') {
      if (htmlData) {
        htmlInIframe(htmlData)
      }
    } else if (currentABTestCampaign === 'B') {
      if (abTestHtmlData) {
        htmlInIframe(abTestHtmlData)
      }
    }

  }, [currentABTestCampaign])

  return (
    <>
      <div class='modal fade kwDesignModal kwCampaignViewModal' id='campaignDesignView'>
        <div class='modal-dialog kw_md'>
          <div class='modal-content'>
            <div class='modal-header'>
              <button type='button' class='close' data-dismiss='modal'>
                <span class='icon-Group-240'></span>
              </button>
            </div>
            <div class='modal-body'>
              <div className='ifame-wrapper'>
                <iframe ref={iFrameRef} style={{ width: "750px", height: "800px", transformOrigin: "0 0", border: "none" }} ></iframe>
              </div>

            </div>
          </div>
        </div>
      </div></>
  )
}
